import { charityConstants } from '../constants/charityConstants';
import { charityService } from '../../services/API/charityService';
import { history }              from '../store/configureStore';

export const  addCharity = (postData) => {
  return dispatch => {
    charityService.addCharity(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.ADD_CHARITY_REQUEST, data } }
  function success(data) { return { type: charityConstants.ADD_CHARITY_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.ADD_CHARITY_FAILURE, error } }
}

export const getCharityList = (postData) => {
  return dispatch => {
    charityService.getCharityList(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.GET_CHARITY_REQUEST, data } }
  function success(data) { return { type: charityConstants.GET_CHARITY_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.GET_CHARITY_FAILURE, error } }
}

export const  deleteCharity = (charityID) => {
  return dispatch => {
    charityService.deleteCharity(charityID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.DELETE_CHARITY_REQUEST, data } }
  function success(data) { return { type: charityConstants.DELETE_CHARITY_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.DELETE_CHARITY_FAILURE, error } }
}

export const  charityStatus = (charityID) => {
  return dispatch => {
    charityService.charityStatus(charityID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.STATUS_CHARITY_REQUEST, data } }
  function success(data) { return { type: charityConstants.STATUS_CHARITY_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.STATUS_CHARITY_FAILURE, error } }
}

export const getCharityDetail = (charityID) => {
  return dispatch => {
    charityService.getCharityDetail(charityID)
    .then(
      data => { 
        dispatch(success(data));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.GET_CHARITYDETAIL_REQUEST, data } }
  function success(data) { return { type: charityConstants.GET_CHARITYDETAIL_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.GET_CHARITYDETAIL_FAILURE, error } }
}

export const  updateCharity = (postData) => {
  return dispatch => {
    charityService.updateCharity(postData)
    .then(
      data => { 
        dispatch(success(data));
      },
     
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) { return { type: charityConstants.ADD_CHARITY_REQUEST, data } }
  function success(data) { return { type: charityConstants.ADD_CHARITY_SUCCESS, data } }
  function failure(error) { return { type: charityConstants.ADD_CHARITY_FAILURE, error } }
}




// WEBPACK FOOTER //
// ./src/app/redux/actions/charityActions.js